import React from "react";

export default function PermissionRequired() {

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <h3>Erişim Yetkiniz Yok</h3>
                </div>
            </div>
        </React.Fragment>
    )
}